// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorMessage_error__2E8yh"};